import { Add } from "@mui/icons-material";
import { Box, Button, Container } from "@mui/material";
import { useState } from "react";

import { useListAllTechCommunitiesQuery } from "api/memberPortal/techCommunities/techCommunities.api";
import { TechCommunity } from "api/memberPortal/techCommunities/techCommunities.types";
import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import TechnicalCommunitiesForm from "../TechnicalCommunitiesForm";

import { getTechnicalCommunitiesColumns } from "./TechnicalCommunities.columns";

const TechnicalCommunitiesTable = () => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedTC, setSelectedTC] = useState<TechCommunity | null>(null);

  const {
    data: communities = [],
    isLoading,
    refetch,
  } = useListAllTechCommunitiesQuery();

  const handleOpenEditModal = (tc: TechCommunity | null) => {
    setSelectedTC(tc);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setSelectedTC(null);
    setShowEditModal(false);
  };

  const columns = getTechnicalCommunitiesColumns(handleOpenEditModal);

  return (
    <Container maxWidth={false}>
      <TechnicalCommunitiesForm
        show={showEditModal}
        onHide={handleCloseEditModal}
        tc={selectedTC}
        // TODO: refactor form to use RTKQ so we dont need this
        refetch={refetch}
      />

      <Box sx={{ mb: 2, display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => handleOpenEditModal(null)}
        >
          Add New
        </Button>
      </Box>

      <DefaultDataGrid
        title="Technical Communities"
        columns={columns}
        rows={communities}
        getRowId={(row) => row.community_id}
        loading={isLoading}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 20 },
          },
          sorting: {
            sortModel: [{ field: "is_international", sort: "desc" }],
          },
        }}
        pageSizeOptions={[10, 20, 50]}
      />
    </Container>
  );
};

export default TechnicalCommunitiesTable;
